import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";

@Component({
    selector: 'eic-asset-operators',
    template: `

    <div *ngIf="assetOperators$ | async as assetOperators">
    <h3>Operator</h3>     
    <table class="projectSectionTable">
    <tr>
        <th>Operator</th>
        <td>{{assetOperators.operator}}</td>
    </tr>
    <tr>
        <th>Contact Name</th>
        <td>{{assetOperators.operatorContactName}}</td>
    </tr>
    <tr>
        <th>Contact Job Title</th>
        <td>{{assetOperators.operatorContactJobTitle}}</td>
    </tr>
    <tr>
        <th>Contact Number</th>
        <td>{{assetOperators.operatorContactNumber}}</td>
    </tr>
    <tr>
        <th>Contact Email</th>
        <td>{{assetOperators.operatorContactEmail}}</td>
    </tr>
        <tr>
        <th>Address</th>
        <td>{{assetOperators.operatorAddress}}</td>
    </tr>
    </table>
    </div>
    `,
    //styleUrls: ['./equipment.styles.scss']
})
export class AssetOperators implements OnInit {
    @Input() assetOperators$: Observable<any[]>;


    constructor() {

    }
  
    ngOnInit(): void {

    }

}